import { Component, h, Prop } from '@stencil/core';
import { CssClassMap, LoaderColour, LoaderType } from './jui-skeleton-loader.model';

@Component({
  tag: 'jui-skeleton-loader',
  styleUrl: 'jui-skeleton-loader.scss',
  shadow: true
})
export class JuiSkeletonLoader {
  /**
   * The number of rows in the loader
   */
  @Prop() count: number = 1;

  /**
   * The height of the loader can be px/percentage/auto etc
   */
  @Prop() height: string;

  /**
   * The width of the loader can be px/percentage/auto etc
   */
  @Prop() width: string;

  /**
   * The variant of the loader can be row/circle
   */
  @Prop() type: LoaderType = LoaderType.row;

  /**
   * The colour of the loader, can be used when rendering a loader on a specific them surface colour eg primary, success
   */
  @Prop() color: LoaderColour = LoaderColour.default;

  /**
   * The sets random widths for loader rows from 70% to 100%
   */
  @Prop() random: boolean = false;

  /**
   * To display inline-block
   */
  @Prop() inline: boolean = false;

  /**
   * To display a default colour loader with transparency
   */
  @Prop() glass: boolean = false;

  /**
   * Removes the default margin from bottom or right (inline loaders)
   */
  @Prop() standalone: boolean = false;

  private getCssClassMap(): CssClassMap {
    return {
      'skeleton-loader': true,
      [this.type]: true,
      [this.color]: true,
      ['inline']: this.inline,
      ['glass']: this.glass,
      ['no-spacing']: this.standalone
    };
  }

  private getStyle() {
    const width = this.random ? this.getRandomWidthPercentage() : this.width;
    return { width, height: this.height };
  }

  private getRandomWidthPercentage(min = 70, max = 100) {
    let difference = max - min;
    let rand = Math.random();
    rand = Math.floor(rand * difference);
    rand = rand + min;
    return `${rand}%`;
  }

  private getLoaderRows(rows) {
    const classMap = this.getCssClassMap();
    let content = [];
    for (let i = 0; i < rows; i++) {
      content.push(<div class={classMap} style={this.getStyle()}></div>);
    }
    return content;
  }

  render() {
    return <div>{this.getLoaderRows(this.count)}</div>;
  }
}
